import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { NavController } from "@ionic/angular";
import { Plugins } from "@capacitor/core";
const { Device } = Plugins;

@Component({
  selector: "footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit {
  @Input()
  hasEditButton: boolean;
  @Input()
  hasBackButton: boolean;
  @Input()
  hasHomeButton: boolean;

  displayAppStore = false;

  @Output() backClicked = new EventEmitter();
  @Output() editClicked = new EventEmitter();
  @Output() homeClicked = new EventEmitter();

  constructor(public nav: NavController) {
    Device.getInfo().then(deviceInfo => {
      console.log("deviceInfo", deviceInfo);
      if ((deviceInfo.operatingSystem == "ios" || deviceInfo.operatingSystem == "android") && deviceInfo.platform == "web") {
        console.log("display app store", deviceInfo.operatingSystem, deviceInfo.platform);
        this.displayAppStore = true;
      }
    });
  }

  ngOnInit() {}

  onBackClicked(): void {
    this.backClicked.emit();
  }
  onEditClicked(): void {
    console.log("edit clicked");
    this.editClicked.emit();
  }
  onHomeClicked(): void {
    this.homeClicked.emit();
  }

  onAppStoreClick(): void {
    window.open("market://details?id=com.latourneedesproducteurs", "_system");
  }
}
